import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './InternalInfoScreen';
import InternalInfo from './InternalInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getInternal } from 'src/store/actions/internal-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        internal: state.internals.current,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getInternal(id)),
    };
}

const InternalInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InternalInfo);

export default InternalInfoScreen;
